import { FC } from 'react';
import { FunnelIcon } from '@phosphor-icons/react';
import CustomSelectInput from '../../../shared/CustomSelectInput/CustomSelectInput';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import Typhography from '../../../shared/Typhography/Typhography';
import { MENU_IN_PORTAL } from '../allenamenti.constants';
import { Option } from './useAnalysisFilter';
import styles from './AnalysisFilterBar.module.scss';

interface IAnalysisFilterBarProps {
  categoryOptions: Option[];
  subcategoryOptions: Option[];
  categoryIds: string[];
  subcategoryIds: string[];
  onCategories: (ids: string[]) => void;
  onSubcategories: (ids: string[]) => void;
  onClear: () => void;
  isFiltering: boolean;
}

/**
 * Filtro della sezione «Blocchi del periodo»: due multi-select
 * Categorie/Sottocategorie (cascata: le sotto sono quelle delle macro scelte),
 * stesso pattern del BlockFormModal. Indispensabile con periodo=stagione, dove
 * i blocchi sono a migliaia.
 */
const AnalysisFilterBar: FC<IAnalysisFilterBarProps> = ({
  categoryOptions,
  subcategoryOptions,
  categoryIds,
  subcategoryIds,
  onCategories,
  onSubcategories,
  onClear,
  isFiltering,
}) => (
  <div className={styles.bar}>
    <div className={styles.head}>
      <FunnelIcon size={16} weight="bold" className={styles.icon} />
      <Typhography size="bold-12" className={styles.title}>
        Filtra per categoria
      </Typhography>
      {isFiltering && (
        <CustomButton size="xs" color="text" onClick={onClear} className={styles.clear}>
          Azzera
        </CustomButton>
      )}
    </div>

    <div className={styles.fields}>
      <CustomSelectInput
        isMulti
        label="Categorie"
        placeholder="— tutte —"
        options={categoryOptions}
        value={categoryIds}
        onChange={(value) => onCategories((value ?? []) as string[])}
        {...MENU_IN_PORTAL}
      />
      {subcategoryOptions.length > 0 && (
        <CustomSelectInput
          isMulti
          label="Sottocategorie"
          placeholder="— tutte le sotto —"
          options={subcategoryOptions}
          value={subcategoryIds}
          onChange={(value) => onSubcategories((value ?? []) as string[])}
          {...MENU_IN_PORTAL}
        />
      )}
    </div>
  </div>
);

export default AnalysisFilterBar;
